import { render, staticRenderFns } from "./AssetSubCategoryTable.vue?vue&type=template&id=48210a5e&scoped=true&"
import script from "./AssetSubCategoryTable.vue?vue&type=script&lang=js&"
export * from "./AssetSubCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetSubCategoryTable.vue?vue&type=style&index=0&id=48210a5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48210a5e",
  null
  
)

export default component.exports